(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["resource-card"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('skre-card-gallery')) {
    customElements.define('skre-card-gallery', class extends HTMLElement {
      get slides() { return Array.from(this.querySelectorAll('[slide-id]')); }
      get initialSlide() { return this.querySelector('[slide-id]'); }
      select({ id }) {
        this.slides.forEach(el => { el.hidden = el.getAttribute('slide-id') != String(id); });
      }
      get refs() { return { slides: this.slides }; }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["skre-load-more"] && !Shopify.designMode) return;
  try {
    class SkrreLoadMore extends HTMLElement {
    #total;
    #fetched;
    #mobileLimit;
    #nextPage;
    #lastPage;
    #sectionId;
    #mobileUnlocked = false;

    connectedCallback() {
      this.#total       = parseInt(this.dataset.total);
      this.#fetched     = parseInt(this.dataset.fetched);
      this.#mobileLimit = parseInt(this.dataset.mobileLimit);
      this.#nextPage    = parseInt(this.dataset.nextPage);
      this.#lastPage    = parseInt(this.dataset.lastPage);
      this.#sectionId   = this.dataset.sectionId;

      /* Hide immediately if everything is already visible */
      const allPagesFetched = this.#nextPage > this.#lastPage;
      if (!this.#isMobile && allPagesFetched) { this.remove(); return; }
      if (this.#isMobile && allPagesFetched && this.#fetched <= this.#mobileLimit) { this.remove(); return; }

      this.querySelector('.skre-lm__btn')?.addEventListener('click', () => this.#handleClick());
    }

    get #isMobile() {
      return !window.matchMedia('(min-width: 750px)').matches;
    }

    async #handleClick() {
      const btn  = this.querySelector('.skre-lm__btn');
      const grid = document.querySelector('[ref="grid"]');
      if (!btn || !grid) return;

      /* ── Step 1: On mobile, reveal the hidden items first ── */
      if (this.#isMobile && !this.#mobileUnlocked) {
        this.#mobileUnlocked = true;
        grid.classList.remove('product-grid--lm-init');

        /* Update the mobile count + bar to show all fetched items */
        this.#updateUI(this.#fetched, this.#fetched);

        /* If there are still more pages, show the button again */
        if (this.#nextPage <= this.#lastPage) {
          btn.disabled = false;
          return;
        }

        this.remove();
        return;
      }

      /* ── Step 2: AJAX-load the next page ── */
      grid.classList.remove('product-grid--lm-init');
      btn.disabled = true;
      btn.textContent = 'Loading…';

      try {
        const url = new URL(window.location.href);
        url.searchParams.set('page', this.#nextPage);
        url.searchParams.set('section_id', this.#sectionId);

        const res = await fetch(url.toString());
        if (!res.ok) throw new Error('fetch failed');

        const doc  = new DOMParser().parseFromString(await res.text(), 'text/html');
        const items = doc.querySelectorAll('[ref="cards[]"]');
        grid.append(...items);

        /* Push a clean URL */
        const cleanUrl = new URL(window.location.href);
        cleanUrl.searchParams.set('page', this.#nextPage);
        cleanUrl.searchParams.delete('section_id');
        history.pushState({}, '', cleanUrl.toString());

        const newFetched = Math.min(this.#fetched + items.length, this.#total);
        this.#fetched  = newFetched;
        this.#nextPage += 1;

        this.#updateUI(newFetched, newFetched);

        if (this.#nextPage > this.#lastPage) {
          this.remove();
        } else {
          btn.disabled = false;
          btn.textContent = 'Load More';
        }
      } catch {
        btn.disabled = false;
        btn.textContent = 'Load More';
      }
    }

    /* Update progress bar + count label for both viewports */
    #updateUI(deskShown, mobShown) {
      const total = this.#total;

      const fillDesk  = this.querySelector('.skre-lm__fill--desk');
      const fillMob   = this.querySelector('.skre-lm__fill--mob');
      const countDesk = this.querySelector('.skre-lm__count--desk');
      const countMob  = this.querySelector('.skre-lm__count--mob');
      const track     = this.querySelector('.skre-lm__track');

      if (fillDesk)  fillDesk.style.width  = `${Math.round(deskShown / total * 100)}%`;
      if (fillMob)   fillMob.style.width   = `${Math.round(mobShown  / total * 100)}%`;
      if (countDesk) countDesk.textContent = deskShown;
      if (countMob)  countMob.textContent  = mobShown;
      if (track)     track.setAttribute('aria-valuenow', this.#isMobile ? mobShown : deskShown);
    }
  }

  if (!customElements.get('skre-load-more')) {
    customElements.define('skre-load-more', SkrreLoadMore);
  }
  } catch(e) { console.error(e); }
})();

})();
